import { createTheme, type MantineColorsTuple } from "@mantine/core";

// ShipSmith navy + red. Headings in Space Grotesk, body in Inter (both self-hosted).
const navy: MantineColorsTuple = [
  "#eef3fb", "#dae3f1", "#b1c4e3", "#86a3d5", "#6387c9", "#4c76c2", "#406dc0", "#325caa", "#2a5199", "#0b1f3a",
];
const red: MantineColorsTuple = [
  "#ffeaec", "#fdd4d6", "#f4a7ab", "#ec777e", "#e64e57", "#e3353f", "#e32732", "#c91a25", "#b41220", "#9e0419",
];

export const theme = createTheme({
  primaryColor: "navy",
  primaryShade: { light: 7, dark: 5 },
  colors: { navy, red },
  fontFamily: "'Inter Variable', system-ui, -apple-system, 'Segoe UI', sans-serif",
  headings: { fontFamily: "'Space Grotesk Variable', 'Inter Variable', system-ui, sans-serif", fontWeight: "650" },
  defaultRadius: "md",
});
